import React, { useEffect, useState, useRef } from "react";
import { Box, useTheme } from "@mui/material";

const AbstractBackground = ({ animate }) => {
  const theme = useTheme();
  const numCurves = 20;
  const height = 800;

  const colors =
    theme.palette.mode === "dark"
      ? ["rgb(26, 26, 64)", "rgba(79, 17, 121, 0.26)"]
      : ["rgb(186, 85, 211)", "rgb(32, 178, 170)"];

  const generateCurves = (width) => {
    if (!width) return [];
    return [...Array(numCurves)].map((_, i) => ({
      d: `M 0,${(i / numCurves) * height} Q ${width / 2 + (Math.random() * width) / 4
        },${Math.random() * height} ${width},${(i / numCurves) * height}`,
      stroke: colors[i % colors.length],
      strokeOpacity: 0.02 + Math.random() * 0.05,
      strokeWidth: 700 + Math.random() * 3,
    }));
  };

  const [curves, setCurves] = useState([]);
  const [width, setWidth] = useState(0);
  const containerRef = useRef(null);

  // 👇 Dynamically get real width using ResizeObserver
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const newWidth = entries[0].contentRect.width;
      setWidth(newWidth);
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Generate curves when width or theme changes
  useEffect(() => {
    if (width > 0) {
      setCurves(generateCurves(width));
    }
  }, [width, theme.palette.mode]);

  // Animate curves if needed
  useEffect(() => {
    if (animate && width > 0) {
      setCurves(generateCurves(width));
    }
  }, [animate]);

  return (
    <Box
      ref={containerRef}
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: -1,
        pointerEvents: "none",
      }}
    >
      {width > 0 && (
        <svg
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${width} ${height}`}
        >
          {curves.map((curve, i) => (
            <path
              key={i}
              d={curve.d}
              stroke={curve.stroke}
              strokeOpacity={curve.strokeOpacity}
              strokeWidth={curve.strokeWidth}
              fill="transparent"
              style={{
                transition: "d 1s ease-in-out, stroke-opacity 1s ease-in-out",
              }}
            />
          ))}
        </svg>
      )}
    </Box>
  );
};

export default AbstractBackground;
